<template>
  <div id="app" :class="[from === 'dongyu' ? 'app-dongyu' : 'app-xinghe', { 'app-pc-home': showPcHome }]">
    <PcHome v-if="showPcHome" />
    <template v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  // import wx from "weixin-js-sdk";
  import '../src/assets/css/reset.scss'
  import '../src/assets/css/common.scss'
  import PcHome from '@/components/pc/index/home.vue'
  import { checkMiniProgramEnv } from '@/common/env.js'
  import { beginMpAuthSync, finishMpAuthSync, getAuthFromLocation, syncMiniSession } from '@/common/mp-auth.js'

  export default {
    components: {
      PcHome,
    },
    data() {
      return {
        terminal: this.$utils.isMobileOrPc(), //判断终端(pc&mobile)
        // terminal: "mobile", //判断终端(pc&mobile)
        isAndroid: this.$utils.isAndroid(), //判断是否安卓手机
        isIphone: this.$utils.isIphone(), //判断是否苹果手机
        bid: '', //判断地址是否带bid参数，商务联系要显示对应参数
        mini: '', //是否有带mini（只有名片小程序跳转h5链接会有带mini）
        wxid: '', //是否有带wxid（dycm 表示来自东娱传媒，xhmp 表示来自星与名片）
        ticket: '', //是否有带ticket（用于登录）
        device_id: '', //是否有带device_id（用于登录）
        isMiniprogramEnter: false, //是否是小程序进入
        debug: '',
        from: '', //页面来源，是否东娱页面进入
        isSouGouBrowser: '',
        firstLoad: true,
      }
    },
    computed: {
      showPcHome() {
        if (this.terminal !== 'pc') return false
        const name = this.$route && this.$route.name
        if (name === 'DongyuEndorsementWeeklyList' || name === 'DongyuEndorsementWeeklyDetail') return false
        return true
      },
    },
    created() {
      Vue.prototype.terminal = this.terminal
      Vue.prototype.isAndroid = this.isAndroid
      Vue.prototype.isIphone = this.isIphone
      // this.MiniprogramEnter();
      this.isSouGouBrowserEnter()
      const bootAuth = getAuthFromLocation()
      const inIframe = (() => {
        try {
          return window.self !== window.top
        } catch (e) {
          return true
        }
      })()
      if (!inIframe && bootAuth.ticket && sessionStorage.getItem('MP_AWAITING_LOGIN') === '1') {
        document.documentElement.style.visibility = 'hidden'
      }
      beginMpAuthSync()
      this.bootMiniAuth(true)
    },
    mounted() {
      this.$router.onReady(() => {
        this.getBackPageHistoryNum()
        this.getDebug()
        this.getMini()
        this.getWxid()
        this.getBid()
        this.getFrom()
        this.iosSaveEntryUrl()
        this.consumeCrossAuthFromQuery()
      })
      // window.addEventListener(
      //   "pageshow",
      //   () => {
      //     alert("pageshow");
      //   },
      //   false
      // );
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          let isMiniprogramEnter = sessionStorage.getItem('isMiniprogramEnter') === 'true' ? true : false
          if (!isMiniprogramEnter) {
            window.entryUrl = location.href.split('#')[0]
            sessionStorage.setItem('entryUrl', location.href.split('#')[0])
          }
        }
      })
      window.addEventListener('popstate', this.handlePopState)
      window.addEventListener('pageshow', this.handlePageShow)
      this.$utils.listenMiniProgramMessage((data) => {
        if (data && data.ticket) {
          this.bootMiniAuth(false)
        }
      })
    },
    beforeDestroy() {
      window.removeEventListener('popstate', this.handlePopState)
      window.removeEventListener('pageshow', this.handlePageShow)
    },
    watch: {
      $route(to, from) {
        let goBackPage = sessionStorage.getItem('goBackPage') === 'true' ? true : false
        if (!this.firstLoad) {
          if (!goBackPage) {
            let str = '/list/'
            if (to.fullPath.includes(str) && to.name == from.name) {
            } else {
              if (from && from.fullPath) {
                sessionStorage.setItem('MP_H5_PREV_FULLPATH', from.fullPath)
              }
              this.setHistoryNum('add')
            }
          }
        } else {
          this.firstLoad = false
        }
        sessionStorage.removeItem('goBackPage')
      },
    },
    methods: {
      getBackPageHistoryNum() {
        let goBackPageHistoryNum_sessionStorage = sessionStorage.getItem('goBackPageHistoryNum') || 0
        let goBackPageHistoryNum = goBackPageHistoryNum_sessionStorage
          ? goBackPageHistoryNum_sessionStorage
          : this.$route.query.goBackPageHistoryNum
            ? this.$route.query.goBackPageHistoryNum
            : 0
        sessionStorage.setItem('goBackPageHistoryNum', goBackPageHistoryNum)
      },
      setHistoryNum(type) {
        let goBackPageHistoryNum = +sessionStorage.getItem('goBackPageHistoryNum') || 0
        goBackPageHistoryNum = type == 'add' ? goBackPageHistoryNum + 1 : goBackPageHistoryNum - 1
        sessionStorage.setItem('goBackPageHistoryNum', goBackPageHistoryNum)
        sessionStorage.setItem('goBackPage', true)
      },
      handlePopState(event) {
        if (sessionStorage.getItem('MP_COLLAPSE_TICKET_HISTORY') === '1') {
          sessionStorage.removeItem('MP_COLLAPSE_TICKET_HISTORY')
          sessionStorage.removeItem('MP_TICKET_HISTORY_SKIP')
          sessionStorage.setItem('goBackPage', true)
          return
        }
        const skipPop = sessionStorage.getItem('MP_TICKET_HISTORY_SKIP_POP')
        if (skipPop === '1') {
          sessionStorage.setItem('MP_TICKET_HISTORY_SKIP_POP', '2')
          this.setHistoryNum('reduce')
          return
        }
        if (skipPop === '2') {
          sessionStorage.removeItem('MP_TICKET_HISTORY_SKIP_POP')
          sessionStorage.setItem('goBackPage', true)
          return
        }
        this.setHistoryNum('reduce')
      },
      handlePageShow() {
        if (sessionStorage.getItem('MP_LOGIN_RETURN') !== '1') return
        if (localStorage.getItem('tokenLogin')) {
          sessionStorage.removeItem('MP_LOGIN_RETURN')
          sessionStorage.removeItem('MP_TICKET_HISTORY_SKIP')
          this.$bus.$emit('loginSuccess')
          return
        }
        this.bootMiniAuth(false)
      },
      // 记录ios手机首次进入url，用于解决苹果手机分享sdk签名报错
      iosSaveEntryUrl() {
        if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
          window.entryUrl = location.href.split('#')[0]
          sessionStorage.setItem('entryUrl', location.href.split('#')[0])
        }
      },
      getDebug() {
        if (process.env.VUE_APP_ENABLE_DEBUG === '0') {
          this.debug = ''
          sessionStorage.removeItem('debug')
          return
        }
        this.debug = this.$route.query.debug || ''
        if (this.debug) {
          sessionStorage.setItem('debug', this.debug)
        }
      },
      getMini() {
        this.mini = this.$route.query.mini || ''
        if (this.mini) {
          sessionStorage.setItem('mini', this.mini)
        }
      },
      getWxid() {
        this.wxid = this.$route.query.wxid || ''
        if (this.wxid) {
          sessionStorage.setItem('wxid', this.wxid)
        }
      },
      detectMiniProgram() {
        return Promise.race([
          checkMiniProgramEnv().catch(() => false),
          new Promise((resolve) => setTimeout(() => resolve(false), 800)),
        ])
      },
      async bootMiniAuth(allowGuestLogout) {
        if (allowGuestLogout) beginMpAuthSync()
        try {
          const inMini = await this.detectMiniProgram()
          const fromRoute = getAuthFromLocation(this.$route && this.$route.query)
          const result = await syncMiniSession({
            inMini,
            ticket: fromRoute.ticket,
            deviceId: fromRoute.deviceId,
            postData: this.$postData,
            allowGuestLogout,
          })
          this.ticket = fromRoute.ticket
          this.device_id = fromRoute.deviceId
          if (sessionStorage.getItem('MP_AWAITING_LOGIN') === '1' && fromRoute.ticket) {
            sessionStorage.removeItem('MP_AWAITING_LOGIN')
            sessionStorage.setItem('MP_LOGIN_RETURN', '1')
            sessionStorage.setItem('MP_COLLAPSE_TICKET_HISTORY', '1')
            let collapsed = false
            const onPop = () => {
              collapsed = true
            }
            window.addEventListener('popstate', onPop)
            window.history.go(-1)
            setTimeout(() => {
              window.removeEventListener('popstate', onPop)
              if (collapsed) return
              document.documentElement.style.visibility = ''
              sessionStorage.removeItem('MP_LOGIN_RETURN')
              sessionStorage.removeItem('MP_COLLAPSE_TICKET_HISTORY')
              if (result.changed || result.loggedIn) {
                this.$bus.$emit('loginSuccess')
              }
            }, 120)
            return
          }
          document.documentElement.style.visibility = ''
          if (result.changed || result.loggedIn) {
            this.$bus.$emit('loginSuccess')
          }
        } catch (error) {
          console.error('[bootMiniAuth]', error)
          document.documentElement.style.visibility = ''
        } finally {
          if (allowGuestLogout) finishMpAuthSync()
        }
      },
      /** 跨站退出 / token 同步（浏览器 H5，不影响小程序） */
      consumeCrossAuthFromQuery() {
        try {
          if (window.__MP_IN_MINI__) return
          if (sessionStorage.getItem('isMiniprogramEnter') === 'true') return
          const ua = String(navigator.userAgent || '').toLowerCase()
          if (ua.includes('miniprogram')) return
          if (getAuthFromLocation(this.$route && this.$route.query).ticket) return
        } catch (e) {}

        const query = (this.$route && this.$route.query) || {}
        const logout = query.xh_logout
        const xhToken = query.xh_token
        const returnUrl = query.xh_return

        if (logout === '1' || logout === 1) {
          localStorage.removeItem('token')
          localStorage.removeItem('tokenLogin')
          localStorage.removeItem('expires')
          localStorage.removeItem('ticket')
          localStorage.removeItem('uid')
          localStorage.removeItem('headimgurl')
          localStorage.removeItem('nickname')
          this.$bus.$emit('logoutSuccess')
        }

        if (xhToken && typeof xhToken === 'string') {
          localStorage.setItem('token', xhToken)
          localStorage.setItem('tokenLogin', xhToken)
          this.$bus.$emit('loginSuccess')
        }

        if (returnUrl && this.isTrustedCrossReturnUrl(returnUrl)) {
          window.location.replace(returnUrl)
          return
        }

        if (logout || xhToken || returnUrl) {
          this.stripAuthQueryFromUrl()
        }
      },
      isTrustedCrossReturnUrl(url) {
        try {
          const u = new URL(url)
          if (u.protocol !== 'http:' && u.protocol !== 'https:') return false
          const host = u.hostname.toLowerCase()
          if (host === 'localhost' || host === '127.0.0.1') return true
          if (host.endsWith('.dyxh.cc') || host === 'dyxh.cc') return true
          return false
        } catch (e) {
          return false
        }
      },
      stripAuthQueryFromUrl() {
        try {
          const url = new URL(window.location.href)
          ;['ticket', 'device_id', 'xh_logout', 'xh_return', 'xh_token'].forEach((key) => {
            url.searchParams.delete(key)
          })
          const next = `${url.pathname}${url.search}${url.hash}`
          window.history.replaceState({}, '', next)
        } catch (e) {}
      },
      getBid() {
        this.bid = this.$route.query.bid || '' //是否有带bid，有则说明通过分享过来
        if (this.bid) {
          sessionStorage.setItem('bid', this.bid)
        }
      },
      getFrom() {
        this.from = this.$route.query.from || sessionStorage.getItem('from') || ''
        if (this.from == 'dongyu') {
          sessionStorage.setItem('from', this.from)
        }
      },
      // 判断是否小程序进入
      MiniprogramEnter() {
        var ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          // 微信环境
          // console.log("【查看当前环境】:是微信环境");
          sessionStorage.setItem('isWeChat', true)
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              //小程序环境
              this.isMiniprogramEnter = true
              sessionStorage.setItem('isMiniprogramEnter', this.isMiniprogramEnter)
            } else {
              //微信环境
              this.isMiniprogramEnter = false
            }
            // console.log("isMiniprogramEnter:" + this.isMiniprogramEnter);
          })
        } else {
          // 微信外其他浏览器
          // console.log("【查看当前环境】:其他H5环境");
          sessionStorage.setItem('isWeChat', false)
          this.isMiniprogramEnter = false
        }
      },
      isSouGouBrowserEnter() {
        this.isSouGouBrowser = navigator.userAgent.toLowerCase().indexOf('se 2.x') > -1 ? true : false
        // Vue.prototype.isSouGouBrowser = this.isSouGouBrowser;
        Vue.prototype.isSouGouBrowser = false
      },
    },
  }
</script>
<style lang="scss">
  #app.app-pc-home {
    position: fixed;
    inset: 0;
    overflow: hidden;
    background: #120e0b;
  }

  body {
    .down-preview-image {
      .van-image-preview__image--vertical {
        overflow-y: auto;
      }
      .van-image-preview__image img {
        width: 80%;
        height: auto;
        margin: 0 auto;
      }
      &--pc {
        .van-image-preview__image {
          width: 100%;
        }
        .van-image-preview__image img {
          width: 50%;
        }
      }
    }
    // 生成图片预览样式
    .generate-preview-image,
    .generate-volume-preview-image {
      .image-preview-scroll {
        overflow-y: auto;
        .van-image-preview__image {
          height: 100% !important;
        }
      }
      .van-image-preview__image {
        height: auto !important;
      }
      .van-image-preview__image img {
        width: 80%;
        height: auto;
        margin: 0 auto;
      }
    }
    .generate-volume-preview-image {
      .van-image-preview__image {
        // margin-top: -0.6rem;
      }
    }
    .grandceremony-preview-image {
      .van-image-preview__image {
        margin-top: -0.6rem;
      }
      .van-image-preview__image img {
        width: 80%;
        height: auto;
        margin: 0 auto;
        border-radius: 0.32rem;
      }
    }
    .picker-date {
      .el-year-table {
        td.today .cell,
        td .cell:hover,
        .current:not(.disabled) .cell {
          color: #ffca01;
        }
      }
      .el-date-picker__header-label.active,
      .el-date-picker__header-label:hover,
      .el-picker-panel__icon-btn:hover,
      .el-date-table td.available:hover,
      .el-date-table td.today span {
        color: #ffca01;
      }
      .el-date-table td.end-date span,
      .el-date-table td.start-date span {
        background: #ffca01;
      }
      .el-date-table td.today.end-date span,
      .el-date-table td.today.start-date span {
        color: #fff;
      }
    }
    .van-toast--loading {
      .van-toast__loading,
      .van-toast__text {
        color: #ffca01;
      }
    }
  }
</style>
